import type { VariantPickerListItem, VariantPickerModel } from 'autogen/swagger/all';
import { useContext } from 'react';
import styled from 'styled-components';
import { removeListStyling } from 'modules/helpers/mixins';
import { Spacing16, Spacing24 } from 'autogen/design-tokens/tokens';
import VerticalLine from './VerticalItem';
import ListHeader from './ListHeader';
import { containerPadding } from './shared/styles';
import ActiveSectionContext from '../shared/context/activeSection';

// #region Styles
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Spacing24};
`;

const VariantList = styled.ul`
    ${removeListStyling}
    ${containerPadding}

    display: flex;
    flex-direction: column;
    gap: ${Spacing16};
    margin-bottom: ${Spacing24};
`;

// #endregion Styles

export default function VerticalList({
    variants,
    price,
    sectionIndex
}: {
    variants: VariantPickerListItem[];
    price: VariantPickerModel['price'];
    sectionIndex: number;
}) {
    const selectedItem = variants.find((item) => item.isSelected);
    const { activeSectionIndex, setActiveSectionIndex } = useContext(ActiveSectionContext);
    const isActive = sectionIndex === activeSectionIndex;

    return (
        <Wrapper>
            {selectedItem && (
                <ListHeader
                    variant={selectedItem}
                    layoutType="Vertical"
                    price={price}
                    editCallback={
                        !isActive
                            ? () => {
                                  setActiveSectionIndex(sectionIndex);
                              }
                            : undefined
                    }
                />
            )}

            {isActive && (
                <VariantList>
                    {variants.map((variant, index) => (
                        <li key={variant.productId}>
                            <VerticalLine item={variant} radioGroupName={`variantSection_${index}`} />
                        </li>
                    ))}
                </VariantList>
            )}
        </Wrapper>
    );
}
